import { BaseModel } from '@app/shared/models/base';
import { Country } from '@app/shared/models/country';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { Contact } from '@app/shared/models/contact';

export class Address extends BaseModel {
    public street: string;
    public number: string;
    public postalcode: string;
    public postalCode: string; // some address have different prop name
    public city: string;
    public country: Country | string;
    public countryCode: string;
    public country_code: string;
    public phone: string;
    public phone2: string;
    public email: string;
    public fax: string;
    public contacts: Contact[];

    public readonly trans = {
        street: marker('address.street'),
        number: marker('address.number'),
        postalcode: marker('address.postalcode'),
        contacts: marker('address.contacts'),
        city: marker('address.city'),
        country: marker('address.country'),
        phone: marker('address.phone'),
        phone2: marker('address.phone2'),
        email: marker('address.email'),
        fax: marker('address.fax'),
    };

    get getCountryPropertyCode(): string {
        return this.countryCode || this.country_code || (
               this.country ?
                   (typeof this.country === 'string' ? this.country : (<Country>this.country).code) :
                   '');
    }

    constructor(json?: any) {
        super(json);
    }

    protected setObjectMappings(json: any): any {
        return Object.assign(super.setObjectMappings(json), {
            country: !json || json.country && typeof json.country !== 'string' ? new Country(json && json.country) : json.country,
            countryCode: json ? (json.countryCode ? json.countryCode : json.country_code ? json.country_code : '') : '',
            country_code: json ? (json.country_code ? json.country_code : json.countryCode ? json.countryCode : '') : '',
            contacts: json && json.contacts ? json.contacts.map(contact => new Contact(contact)) : new Array<Contact>(),
            postalcode: json ? (json.postalcode ? json.postalcode : json.postalCode ? json.postalCode : '') : '',
            postalCode: json ? (json.postalCode ? json.postalCode : json.postalcode ? json.postalcode : '') : ''
        });
    }

    // Sometimes country is expected by the BE in a different format.
    // Ex: The ClientUser needs format country: string, countryCode: string
    public splitCountry(): void {
        if (this.country instanceof Country) {
            this.countryCode = this.country.code;
            this.country_code = this.country.code;
            this.country = this.country.value;
        }
    }

    public copyPostalCodes(): void {
        const currentPostalCode = this.postalcode;

        this.postalCode = currentPostalCode;
        this.postalcode = currentPostalCode;
    }
}
